module.exports = __webpack_public_path__ + "static/media/snow.4bcf2220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/snow.jpg
// module id = 40
// module chunks = 0